export class ApplyJobDto {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  desiredRole: string;
  experienceYears: number;
  cvUpload: File;
  linkedin: string;
  event: string;
  consent: boolean;
}
